import { IChatViewState } from './types';
import { getChatOpenedGroupIdLocalStorage } from './localStorage/actions/getChatOpenedGroupIdLocalStorage';
import { getChatOpenedChatIdLocalStorage } from './localStorage/actions/getChatOpenedChatIdLocalStorage';

export const getChatViewInitialState = (): IChatViewState => ({
    groups: null,
    chats: {},
    openedGroupId: getChatOpenedGroupIdLocalStorage(),
    openedChatId: getChatOpenedChatIdLocalStorage(),
});
